import React from 'react'
import { Container, ListItem, ListItemContent, ListItemHeader, ListItemSubHeader ,} from '../../style/ShippingNotesWmo.css'
import { CalenderIconWMO, FitIconWMO, ShippingIconWMO } from '@usap/uicomponents'


function ShippingNotesWmo() {
  return (
    <Container>
      {/* item1 */}
      <ListItem>
        <FitIconWMO />
        <ListItemContent>
          <ListItemHeader>Guaranteed to Fit</ListItemHeader>

          <ListItemSubHeader>Convenient vehicle selection</ListItemSubHeader>
        </ListItemContent>
      </ListItem>

      {/* item2 */}

      <ListItem>
        <ShippingIconWMO />
        <ListItemContent>
          <ListItemHeader>Fast Shipping</ListItemHeader>

          <ListItemSubHeader>Get the part when you need it</ListItemSubHeader>
        </ListItemContent>
      </ListItem>

      {/* item3 */}

      <ListItem>
        <CalenderIconWMO />
        <ListItemContent>
          <ListItemHeader>Hassle-Free Returns</ListItemHeader>
          <ListItemSubHeader>
            Simple & convenient online returns
          </ListItemSubHeader>
        </ListItemContent>
      </ListItem>
    </Container>
  );
}

export default ShippingNotesWmo